import { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Form, Button, Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/Loader";
import Message from "../components/Message";
import FormContainer from "../components/FormContainer";
import { listProductDetails, updateProduct } from "../actions/productActions";
import { PRODUCT_UPDATE_RESET } from "../constants/productConstants";

function ProductEditScreen() {
	const { id: productId } = useParams();
	const navigate = useNavigate();

	const [name, setName] = useState("");
	const [price, setPrice] = useState(0);
	const [image, setImage] = useState("");
	const [brand, setBrand] = useState("");
	const [category, setCategory] = useState("");
	const [countInStock, setCountInStock] = useState(0);
	const [description, setDescription] = useState("");
	const [uploading, setUploading] = useState(false);
	const [isBackorderAvailable, setIsBackorderAvailable] = useState(false);
	const [backorderAvailabilityDate, setBackorderAvailabilityDate] =
		useState("");

	const dispatch = useDispatch();

	const productDetails = useSelector((state) => state.productDetails);
	const { error, loading, product } = productDetails;

	const productUpdate = useSelector((state) => state.productUpdate);
	const {
		error: errorUpdate,
		loading: loadingUpdate,
		success: successUpdate
	} = productUpdate;

	useEffect(() => {
		if (successUpdate) {
			dispatch({ type: PRODUCT_UPDATE_RESET });
			navigate("/admin/productlist");
		} else {
			if (!product.name || product._id !== Number(productId)) {
				dispatch(listProductDetails(productId));
			} else {
				setName(product.name);
				setPrice(product.price);
				setImage(product.image);
				setBrand(product.brand);
				setCategory(product.category);
				setCountInStock(product.countInStock);
				setDescription(product.description);
				setIsBackorderAvailable(product.isBackorderAvailable);
				setBackorderAvailabilityDate(product.backorderAvailabilityDate || "");
			}
		}
	}, [dispatch, product, productId, navigate, successUpdate]);

	const submitHandler = (e) => {
		e.preventDefault();
		dispatch(
			updateProduct({
				_id: productId,
				name,
				price,
				image,
				brand,
				category,
				countInStock,
				description,
				isBackorderAvailable,
				backorderAvailabilityDate
			})
		);
	};

	const uploadFileHandler = async (e) => {
		const file = e.target.files[0];
		const formData = new FormData();

		formData.append("image", file);
		formData.append("product_id", productId);

		setUploading(true);

		try {
			const config = {
				headers: {
					"Content-Type": "multipart/form-data"
				}
			};

			const { data } = await axios.post(
				"/api/products/upload/",
				formData,
				config
			);

			setImage(data);
			setUploading(false);
		} catch (error) {
			setUploading(false);
		}
	};

	return (
		<div>
			<Container>
				<Link to="/admin/productlist">Go Back</Link>

				<FormContainer>
					<h1>Edit Product</h1>
					{loadingUpdate && <Loader />}
					{errorUpdate && <Message variant="danger">{errorUpdate}</Message>}

					{loading ? (
						<Loader />
					) : error ? (
						<Message variant="danger">{error}</Message>
					) : (
						<Form onSubmit={submitHandler}>
							<Form.Group controlId="name">
								<Form.Label>Name</Form.Label>
								<Form.Control
									type="name"
									placeholder="Enter name"
									value={name}
									onChange={(e) => setName(e.target.value)}></Form.Control>
							</Form.Group>

							<Form.Group controlId="price">
								<Form.Label>Price</Form.Label>
								<Form.Control
									type="number"
									placeholder="Enter price"
									value={price}
									onChange={(e) => setPrice(e.target.value)}></Form.Control>
							</Form.Group>

							<Form.Group controlId="image">
								<Form.Label>Image</Form.Label>
								<Form.Control
									type="text"
									placeholder="Enter image"
									value={image}
									onChange={(e) => setImage(e.target.value)}></Form.Control>
								<input
									id="image-file"
									type="file"
									onChange={uploadFileHandler}
								/>
								{/* <Form.File
                id="image-file"
                label="Choose File"
                custom
                onChange={uploadFileHandler}></Form.File> */}
								{uploading && <Loader />}
							</Form.Group>

							<Form.Group controlId="brand">
								<Form.Label>Brand</Form.Label>
								<Form.Control
									type="text"
									placeholder="Enter brand"
									value={brand}
									onChange={(e) => setBrand(e.target.value)}></Form.Control>
							</Form.Group>

							<Form.Group controlId="countinstock">
								<Form.Label>Stock</Form.Label>
								<Form.Control
									type="number"
									placeholder="Enter stock"
									value={countInStock}
									onChange={(e) =>
										setCountInStock(e.target.value)
									}></Form.Control>
							</Form.Group>

							<Form.Group controlId="category">
								<Form.Label>Category</Form.Label>
								<Form.Control
									type="text"
									placeholder="Enter category"
									value={category}
									onChange={(e) => setCategory(e.target.value)}></Form.Control>
							</Form.Group>

							<Form.Group controlId="description">
								<Form.Label>Description</Form.Label>
								<Form.Control
									type="text"
									placeholder="Enter description"
									value={description}
									onChange={(e) =>
										setDescription(e.target.value)
									}></Form.Control>

								<Form.Group controlId="isBackorderAvailable">
									<Form.Check
										type="checkbox"
										label="Available for Backorder"
										checked={isBackorderAvailable}
										onChange={(e) => setIsBackorderAvailable(e.target.checked)}
									/>
								</Form.Group>
							</Form.Group>
							<Form.Group controlId="backorderAvailabilityDate">
								<Form.Label>Backorder Availability Date</Form.Label>
								<Form.Control
									type="date"
									value={backorderAvailabilityDate}
									onChange={(e) => setBackorderAvailabilityDate(e.target.value)}
								/>
							</Form.Group>

							<Button type="submit" variant="primary">
								Update
							</Button>
						</Form>
					)}
				</FormContainer>
			</Container>
		</div>
	);
}

export default ProductEditScreen;
